export default "__VITE_ASSET__BcBnvuy9__"